// Generated by ReScript, PLEASE EDIT WITH CARE


function getImage(name) {
  var requireImage = (function(name){
        return require(`CrmAssets/images/${name}`).default
      });
  return requireImage(name);
}

function importCss(param) {
  return (require(`CrmAssets/styles/_crmMain.scss`));
}

export {
  getImage ,
  importCss ,
  
}
/* No side effect */
